<template>
  <div class="etr">
    <!-- {{ search }} -->
    <!-- <br /><br />
    {{ item }}<br /><br /> -->
    <b-card class="mt-3">
      <b-card-header>
        <b-row align-v="center" no-gutters>
          <b-col cols="8">
            <b-button-group>
              <b-button
                v-print="'#paper'"
                squared
                size="sm"
                class="mr-4"
                title="Print"
              >
                <i class="fa fa-print pr-3"></i>Print
              </b-button>
              <div class="inline-block" align-v="center">
                <i class="fa fa-book fa-2x mr-1 text-primary"></i>

                <span class="h4 ml-1">{{ item.locator }}</span>
              </div>
            </b-button-group>
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <!-- <b-button
                v-if="(user.rolename = 'admin')"
                class="mr-1"
                squared
                size="sm"
                variant="primary"
                @click="download()"
              >
                <i
                  :class="
                    busy
                      ? 'fa fa-spinner fa-spin pr-3'
                      : 'fa fa-file-pdf-o pr-3'
                  "
                ></i
                >Download
              </b-button> -->
              <b-button squared size="sm" variant="secondary" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button></b-button-group
            >
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-overlay
          :show="busy"
          spinner-type="grow"
          spinner-variant="primary"
          rounded="sm"
        >
          <div
            id="paper"
            class="mb-3 p-5 background-white text-secondary componentview"
          >
            <div>
              <!-- <b-row class="header text-muted mb-4" no-gutters>
                <b-col cols="1"
                  ><img
                    class="logo mt-4 ml-5 h-50px"
                    src="/img/brand/ABTA.jpg"
                    alt="ABTA"
                /></b-col>
                <b-col class="text-center"
                  ><img
                    class="logo mb-3"
                    src="/img/brand/RGB Travel Places Primary Logo.bmp"
                    alt="Travel Places"
                    height="70"
                    width="190"
                  /><br />
                  <span>
                    Podium House 61 Chapel Road, Worthing, West Sussex, BN11
                    1HR<br />
                    Tel Accounts: +44 (0) 1903 832 899 Tel Sales: +44 (0) 1903
                    832888 Fax: +44 (0) 1903 231743</span
                  >
                </b-col>
                <b-col cols="1" class="mt-4 mr-5 text-right">
                  <img
                    class="logo h-30px"
                    src="/img/brand/IATA.jpg"
                    alt="IATA"
                  />
                </b-col>
              </b-row> -->
              <b-row class="border-bottom" no-gutters>
                <b-col class="text-center large uppercase strong">
                  PNR ACCOUNTING DATA LINES
                </b-col>
              </b-row>
              <div class="large">
                <b-row class="my-4">
                  <b-col class="strong">
                    {{ item.to }} <br />
                    <div v-html="$helpers.breaklines(item.address)"></div>
                  </b-col>
                  <b-col class="text-right">
                    <b-row>
                      <b-col><span> PNR Date and Time: </span></b-col>
                      <b-col
                        >
                        {{
                          this.$moment
                            .unix(item.dateissued / 1000)
                            .utc()
                            .format("YYYY-MM-DD HH:mm:ss")
                        }}
                      </b-col>
                    </b-row>
                    <b-row class="my-1">
                      <b-col>Locator:</b-col> <b-col>{{ item.locator }}</b-col>
                    </b-row>
                    <b-row class="my-1">
                      <b-col>Agent:</b-col> <b-col>{{ item.agent }}</b-col>
                    </b-row>
                    <b-row class="my-1">
                      <b-col>Event:</b-col> <b-col>{{ item.eventcode }}</b-col>
                    </b-row>
                    <b-row class="my-1">
                      <b-col>SLAC:</b-col> <b-col>{{ item.slac }}</b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <div>
                  <table v-if="item.document" class="invoicetable">
                    <thead>
                      <tr>
                        <th
                          v-for="(field, findex) in item.document.fields"
                          :key="findex"
                          class="border-right-secondary"
                          :colspan="field.colspan"
                        >
                          <span v-html="$helpers.breaklines(field.label)" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- SPACER -->
                      <tr class="spacer">
                        <template v-for="(col, cindex) in item.document.fields">
                          <td
                            :key="cindex"
                            :class="'border-right-secondary v-align-top'"
                          ></td>
                        </template>
                      </tr>
                      <tr
                        v-for="(row, rindex) in item.document.items"
                        :key="rindex"
                      >
                        <td
                          v-for="(col, cindex) in row"
                          :key="cindex"
                          :class="
                            item.document.fields[cindex].class +
                            ' border-right-secondary v-align-top'
                          "
                        >
                          <span v-html="$helpers.breaklines(col)" />
                        </td>
                      </tr>
                      <!-- SPACER -->
                      <tr class="spacer">
                        <template v-for="(col, cindex) in item.document.fields">
                          <td
                            :key="cindex"
                            :class="'border-right-secondary v-align-top'"
                          ></td>
                        </template>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="strong border-top-secondary">
                        <td></td>
                        <td colspan="1">Totals GBP</td>
                        <td class="text-right border-left-secondary">
                          {{ Math.abs(item.price) | currency("") }}
                        </td>
                        <td class="text-right border-left-secondary">
                          {{ Math.abs(item.taxes) | currency("") }}
                        </td>
                        <!--   <td class="text-right border-left-secondary">
                          {{ Math.abs(item.fees) | currency("") }}
                        </td> -->
                        <td class="text-right border-left-secondary">
                          {{ Math.abs(item.cost) | currency("") }}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "PNRView",
  data() {
    return {
      busy: false,
      item: {
        items: [],
      },
      slac: null,
    };
  },
  methods: {
    async load() {
      this.busy = true;

      let variables = {
        id: this.idselected,
        dateformat: "DD/MM/YYYY HH:MM:SS",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query PNR_Statement($id: String, $dateformat: String) {
              PNR_Statement(id: $id, dateformat: $dateformat) {
                version

                dateissued
                locator
                agent
                eventcode
                slac
                price
                taxes
                fees
                cost
                document {
                  fields {
                    key
                    label
                    class
                    colspan
                  }
                  items
                }
              }
            }
          `,
          variables,
        });

        this.item = response.data.PNR_Statement;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async download() {
      this.busy = true;
      let variables = {
        source: this.search.source,
        datestatement: this.search.datestatement,
        statementtype: this.search.statementtype
          ? this.search.statementtype.join(",")
          : null,
        slac: this.search.selected.slac,
        documentformat: "STM_1",
        dateformat: "DD/MM/YYYY HH:MM:SS",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
          query PNR_Statement(
              $locator: String
            $dateformat: String
            ) {
              PNR_Statement(
                locator: $locator     
                dateformat: $dateformat         
              ) {               
               version               
               dateissued
               locator
               agent
               taxes
               fees
               costtotal
               items
             
                }
              }
            }
          `,
          variables,
        });
        if (response.data.statements.length > 0) {
          let byteCharacters = atob(response.data.statements[0].documentpdf);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/pdf" });
          fs.saveAs(
            blob,
            "stm_" +
              response.data.statements[0].slac +
              "_" +
              this.$moment().format("_YYYYDDMMHHMMSS") +
              ".pdf"
          );
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    discard() {
      this.$emit("discard");
    },
  },
};
</script>

<style>
.invoicetable {
  font-size: 0.8em;
}
.invoicetable tfoot tr {
  font-size: 1em;
}
</style>
